import { createSelector } from 'reselect'
import entryDataSelector from '../entryDataSelector'

const countrySelector = createSelector(
    entryDataSelector,
    (entryData): string => entryData.country || '',
)

export default countrySelector
